import { useMutation } from "@tanstack/react-query";
import authService from "~/services/auth.service";

export function useLoginMutation() {
  return useMutation((payloads) => authService.login(payloads));
}

export function useForgetPasswordMutation() {
  return useMutation((payloads) => authService.forgetPassword(payloads));
}
export function useChangePasswordMutation() {
  return useMutation((payloads) => authService.changePassword(payloads));
}
